export const generateLinkWithParams = (
    baseUrl: string,
    referer: string | null,
    medium: string | null,
    extraParams?: Record<string, string | null | undefined>,
  ) => {
    const urlParams = new URLSearchParams();
    if (referer) {
      urlParams.set('referer', referer);
    }
    if (medium) {
      urlParams.set('medium', medium);
    }
    if (extraParams) {
      Object.entries(extraParams).forEach(([key, value]) => {
        if (value) {
          urlParams.set(key, value);
        }
      });
    }
    const queryString = urlParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  };
  